import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import {
  ServiceMarketplaceDto,
  CustomModalActionType,
} from "@green0meter/api-client";

import { Box, Typography, Card, CardContent, Button, Stack } from "@components/base";
import { useSetServiceImInterested, useGetCustomModals } from "@api";
import { GetInTouchModal } from "@components/common";
import { useUserStore } from "@store/user";

interface ServiceDescriptionProps {
  serviceDescription: string;
  service: ServiceMarketplaceDto;
}

const ServiceDescription: FC<ServiceDescriptionProps> = ({
  serviceDescription,
  service,
}) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { customModals } = useGetCustomModals();
  const { setServiceImInterestedEnabled, isPendingSetServiceImInterested } =
    useSetServiceImInterested(user);
  const [isGetInTouchModalOpen, setIsGetInTouchModalOpen] = useState(false);

  const handleEnable = (): void => {
    setIsGetInTouchModalOpen(true);
  };

  const handleCloseGetInTouchModal = (): void => {
    setIsGetInTouchModalOpen(false);
  };

  return (
    <>
      <Card>
        <CardContent>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" fontWeight={500}>
              {t("serviceDetails.serviceDescription")}
            </Typography>
            {setServiceImInterestedEnabled && (
              <Button
                variant="contained"
                size="small"
                startIcon={<FeatherIcon icon="check-circle" size={12} />}
                onClick={handleEnable}
                disabled={
                  isPendingSetServiceImInterested ||
                  service.imInterested ||
                  service.isNotRelevant
                }
                sx={{
                  backgroundColor: "common.black",
                  color: "common.white",
                  "&:hover": {
                    backgroundColor: "grey.800",
                  },
                }}
              >
                {t("serviceActions.enable", "Activate")}
              </Button>
            )}
          </Stack>
          <Box mt={2}>
            <Typography variant="body2">
              <div dangerouslySetInnerHTML={{ __html: serviceDescription }}></div>
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <GetInTouchModal
        open={isGetInTouchModalOpen}
        data={customModals?.find(
          (modal) => modal.actionType === CustomModalActionType.GetInTouchGeneral,
        )}
        onClose={handleCloseGetInTouchModal}
      />
    </>
  );
};

export default ServiceDescription;
